import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import Swal from "sweetalert2";
import { LeaveOpeningAPI } from "../../../../api/Payroll/Leaveopening";
import classnames from "classnames";
const LeaveMasterModel = ({ school_id, onSave, leaveData }) => {
  const [activeTab, setActiveTab] = useState("1");
  const [modal, setModal] = useState(false);
  const [newLeave, setLeave] = useState("");
  const [errors, setErrors] = useState(false);
  const [leaveList, setLeaveList] = useState([]);

  console.log(leaveData, "leaveData");

  const [editId, setEditId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleEdit = (item) => {
    console.log(item);
    setLeave(item.label);
    setEditId(item.value);
    setIsEditMode(true);
    toggleTab("1");
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this leave type!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let data = {
          leave_type_id: id,
          school_id: school_id,
        };
        const response = await LeaveOpeningAPI.delete_leave_type(data);
        const responseData = response.data;
        if (responseData.status === 200) {
          Swal.fire("Deleted!", "Your leave type has been deleted.", "success");
          onSave();
        } else {
          Swal.fire("Error!", responseData.msg, "error");
        }
      }
    });
  };

  const toggle = (e) => {
    e.preventDefault();
    setModal(!modal);
    setLeave("");
  };

  const addNewLeave = async (e) => {
    e.preventDefault();
    if (newLeave === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Enter Leave Type",
      });
      return;
    } else {
      try {
        let data = {
          school_id: school_id,
          leave_type: newLeave,
        };
        if (isEditMode) {
          let data = {
            leave_type_name: newLeave,
             school_id: school_id,
             leave_type_id: editId
          };
        
          const response = await LeaveOpeningAPI.edit_leave_type(data);
          const responseData = response.data;
          if (responseData.status === 200) {
            Swal.fire({
              icon: "success",
              text: responseData.msg,
            });
            onSave();
            setModal(!modal);
            setLeave("");
            setEditId(null);
            setIsEditMode(false);
            

          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: responseData.msg,
            });
          }
        } else {
          const response = await LeaveOpeningAPI.saveLeaveType(data);
          console.log(response);
          const responseData = response.data;
          console.log(responseData);
          if (responseData.status === 200) {
            Swal.fire({
              icon: "success",
              text: responseData.msg,
            });
            onSave();
            setModal(!modal);
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: responseData.msg,
            });
          }
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  return (
    <div>
      <button className="btn btn-primary" onClick={toggle}>
        <i className="fa fa-plus-square pr-1"></i>
      </button>
      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader >Leave Management</ModalHeader>
        <ModalBody>
          {/* Tabs */}
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "1" })}
                onClick={() => toggleTab("1")}
                style={{ cursor: "pointer" }}
              >
                {editId ? "Edit Leave" : "Add Leave"}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => toggleTab("2")}
                style={{ cursor: "pointer" }}
              >
                All Leaves
              </NavLink>
            </NavItem>
          </Nav>

          {/* Tab Contents */}
          <TabContent activeTab={activeTab} className="mt-3">
            {/* Add/Edit Leave */}
            <TabPane tabId="1">
              <div className="form-group">
                <label>Leave Type</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Leave Type"
                  value={newLeave}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (/^[a-zA-Z\s]*$/.test(newValue)) {
                      setLeave(newValue);
                    }
                  }}
                />
              </div>
            </TabPane>

            {/* View All Leaves */}
            <TabPane tabId="2">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Leave Type</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {leaveData.length > 0 ? (
                    leaveData.map((leave) => (
                      <tr key={leave.value}>
                        <td>{leave.value}</td>
                        <td>{leave.label}</td>
                        <td>
                          <Button
                            color="secondary"
                            size="sm"
                            className="mx-2"
                            onClick={() => handleEdit(leave)}
                          >
                            Edit
                          </Button>
                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => handleDelete(leave.value)}
                          >
                            Delete
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center">
                        No leaves found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </TabPane>
          </TabContent>
        </ModalBody>
        <ModalFooter>
          {activeTab === "1" && (
            <Button
              className="btn btn-primary"
              type="button"
              onClick={addNewLeave}
            >
              {editId ? "Update" : "Save"}
            </Button>
          )}
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default LeaveMasterModel;
